import React, { useEffect, useState } from "react";
import { getUrl } from "aws-amplify/storage";
import { Image} from 'react-bootstrap';
// import { DEFAULT_USER_IMAGE } from "../../config";
import { S3_BUCKET , DEFAULT_USER_IMAGE } from "../../config";
import { AgendaPost, AgendaUser } from "../../graphql/API";
// import DEFAULT_USER_IMAGE from "../../assets/images/no-avatar.jpg";
// import { CacheManager, CachedImage } from '@georstat/react-native-image-cache';

interface IUserImage {
    user: any;
    image?: string;
    avatarStyle?: any;
    customClass?: string;
};

const UserImage = ({user, image, avatarStyle, customClass}: IUserImage) => {
    // console.log('STYLE', user.image);
    // const [cacheSize, setCacheSize] = useState<number | null>(null);
    // const [isCached, setIsCached] = useState<boolean | null>(null);
    const [imageUri, setImageUri] = useState<string>(S3_BUCKET+ (image ? image : (user ? (user.image ? user.image : '') : ''))); //('');
    

    // useEffect(() => {
    //     // const fetchCacheSize = async () => {
    //     //     try {
    //     //         const size = await CacheManager.getCacheSize(); // Récupère la taille du cache en octets
    //     //         setCacheSize(size);
    //     //     } catch (error) {
    //     //         console.error("Erreur lors de la récupération de la taille du cache :", error);
    //     //     }
    //     // };
    //     const fetchIsCached = async () => {
    //         try {
    //             // const falseImg = "https://4nkh.ca/static/authors/images/no-avatar.jpg"
    //             // const uri = "https://amplify-schedulum-4nkh-sa-schedulumdrivebucket775c-j6met6z19khi.s3.us-east-1.amazonaws.com/public/acfbe7fb-9b2b-46fb-b598-b3567b87e277.jpg";
    //             // const isImageCached = await CacheManager.isImageCached(imageUri);
    //             // setIsCached(isImageCached);
    //         } catch (error) {
    //             console.error("Erreur lors de la récupération du cache :", error);
    //         }
    //         // await CacheManager.clearCache();
    //     };

    //     // fetchCacheSize();
    //     fetchIsCached();
    // }, []);

    // useEffect(() => {
    //     Alert.alert((cacheSize?.toString() || "0"));
    // }, [cacheSize]);
    // useEffect(() => {
    //     Alert.alert((isCached?.toString() || "false"));
    // }, [isCached]);

    useEffect(() => {
        if (image) {
            getImageUrl();
        } else {
            if (user && user.image) {
                getImageUrl();
            }
        }
    }, [user, image]);

    const getImageUrl = async () => {
        if (image || (user && user.image)) {
            // if (isCached == false) {
            // console.log('IMG', image);
                const response = await getUrl({
                    key: image ? image : user.image,
                });
                const origin = response.url.origin;
                const path = response.url.pathname.split('%20')[0];
                const uri = origin + path;
                setImageUri(uri);
                // console.log('uri',uri);
                // setImageUri(response?.url.toString());
            // }
        };
    };
 
    return (
        // <Image source={{uri: imageUri || DEFAULT_USER_IMAGE}} style={avatarStyle} />
        <>
        {imageUri != S3_BUCKET && imageUri != S3_BUCKET + "null" ?
        // "https://amplify-schedulum-4nkh-sa-schedulumdrivebucket775c-j6met6z19khi.s3.us-east-1.amazonaws.com/public/null" ?
                // <CachedImage
                // source="https://4nkh.ca/static/authors/images/logo1.png"
            //     style={{ height: 350, width: 150 }}
                // style={{"borderRadius": 50, "height": 100, "width": 100, "backgroundColor": 'red'}}
            //     thumbnailSource="https://via.placeholder.com/350x150"
            //   />
            // <CachedImage source={imageUri} style={{"borderRadius": 50, "height": 100, "width": 100, "backgroundColor": 'red', 'overflow': 'hidden'}} maxAge={48} />
            
            // <Image source={{uri: imageUri}} style={avatarStyle} />

            // CachedImage using a position absolute for the image ...useimagestyle for boderRadius ...
            // <CachedImage source={imageUri} imageStyle={{"borderRadius": 100, "aspectRatio": 1}} style={avatarStyle} maxAge={48} />
            // <CachedImage source={imageUri} imageStyle={{"borderRadius": 200}} style={avatarStyle} maxAge={48} />
            <>
            {/* <div style={{'overflow': 'hidden', 'backgroundColor': 'black'}}> */}
            <Image src={imageUri} className={customClass} />
            {/* </div> */}
            </>
        :
            <Image src={DEFAULT_USER_IMAGE} alt="User" className={customClass} />
        }
        </>
    );
};

export default UserImage;